export default __webpack_public_path__ + "static/media/lds-logo_mn.f2cf3bc12e2e9930.svg";